import { render } from "./HezabatCustomersPage.vue?vue&type=template&id=4d91293d"
import script from "./HezabatCustomersPage.vue?vue&type=script&lang=js"
export * from "./HezabatCustomersPage.vue?vue&type=script&lang=js"

import "@/assets/scss/hezabat.scss?vue&type=style&index=0&lang=scss"
import "@/assets/scss/report-page.scss?vue&type=style&index=1&lang=scss"

import exportComponent from "C:\\Users\\Rufiz Huseynzada\\OneDrive - Azerbaijan State Oil and Industry University\\Desktop\\ProgressProjects\\AgentModule\\web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__